import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import { config } from '@/../app.config'
import { EventBus } from '@/utils/eventbus'
import Auth from '@aws-amplify/auth'
import { ILocationUpdate } from '@/store/modules/cart/interfaces'
import { GetLocation } from '@/utils/GameUtils'
import Axios from 'axios'
import GameFooter from '@/components/Game/Footer'
import NewsPanel from '@/components/Game/NewsPanel'
import { INewsArticle } from '@/store/modules/game/interfaces'

@Component
export default class Home extends Vue {

  private async postSigninAuth(cb: () => void) {
    //console.log('DEBUG: Home:postSigninAuth')
    const data = await Auth.currentUserInfo()
    //console.log('DEBUG: Home:postSigninAuth:currentUserInfo:Result')

    //console.log('DEBUG: Home:postSigninAuth:GetLocation')
    const geoBundle = await GetLocation().then( (position: Position) => {
      //console.log('DEBUG: Home:postSigninAuth:GetLocation:Result')
      //console.log(`DEBUG: position ${position}`)
      const res = {
        altitude: position.coords.altitude, 
        latitude: position.coords.latitude, 
        longitude: position.coords.longitude, 
        accuracy: position.coords.accuracy, 
        speed: position.coords.accuracy, 
        timestamp: position.timestamp
      } as ILocationUpdate
      return res
    }).catch( (err) => {
      //console.log('failed to get geo data', err)
      //@ts-ignore
      Sentry.captureException(`${err}`);
      return null
    })

    console.log('DEBUG: Home:postSigninAuth:guardFunctions')
    if (!data || !data.id) {
      this.forceAuthSigOut('Your authentication information cannot be checked. Please contact support')
      return;
    }

    if (!geoBundle) {
      this.forceAuthSigOut('Geolocation must be enabled and active to continue playing. Please try again')
      return;
    }
    
    //console.log('DEBUG: Home:postSigninAuth:Axios')
    Axios.post(`${config.apiEndpoint}/auth`, {
      uid: data.id,
      geo: geoBundle
    })
      .then(result => {
        //console.log('DEBUG: Home:postSigninAuth:Axios:Success')
        this.$store.dispatch('SET_BALANCE', result.data.balance)
        this.$store.dispatch('SET_USERNAME', data.username)

        EventBus.$emit('qpAuthenticated', data.id)
        //@ts-ignore
        heap.track('game:signin:complete')

        cb()
      })
      .catch(err => {
        //console.log('DEBUG: Home:postSigninAuth:Axios:Failure')
        //@ts-ignore
        Sentry.captureException(`${err}`);
        this.forceAuthSigOut('Your account cannot be authenticated. Please contact support')
        //@ts-ignore
        heap.track('game:signin:error')
      });
  }

  private forceAuthSigOut(msg: string) {
    // @ts-ignore
    //this.$awn.alert(msg)
    this.genErrorDialog(msg)
  }

  private created() {

    this.$store.dispatch('SET_LOADINGSTATE', true)

    //console.log('DEBUG: Home:created')
    this.$store.dispatch('GET_NEWS').then((news) => {
      //console.log('DEBUG: Home:created:GET_NEWS:Result')
      this.$store.dispatch('SET_LOADINGSTATE', false)
      //console.log('DEBUG: Home:created:postSigninAuth')
      this.postSigninAuth(() => {
        //console.log('DEBUG: Home:created:postSigninAuth:Result')
        if (news.panels.length === 0) {
          //this.$router.push('lobby')
          return
        }
      })
    })
  }

  private genErrorDialog(msg: string) {
    this.$modal.show('dialog', {
      text: msg,
      buttons: [
        {
          title: 'Sign out',
          handler: () => { this.$router.push('signOut') }
        }
     ],
    })
  }

  private modeSelect(isClassic: boolean) {
    if (isClassic) {
      this.$router.push('virtual')
    } else {
      this.$router.push('lobby')
    }
  }

  private render(h: any) {
    let loader: JSX.Element | null = null
    if (this.$store.getters.LOADING) {
      loader = <div class='lds-grid'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    }

    const tutorialPanel = {
      title: 'How to play',
      body: 'How to play',
      action: 'goto:tutorial',
    } as INewsArticle

    let newsPanels: JSX.Element[] = []
    if (!this.$store.getters.LOADING) {
      // @ts-ignore
      //newsPanels.push(<NewsPanel article={tutorialPanel}></NewsPanel>)

      this.$store.getters.NEWS.panels.forEach((panel: INewsArticle) => {
        // @ts-ignore
        newsPanels.push(<NewsPanel article={panel}></NewsPanel>)
      })
    }

    let modeSelect: JSX.Element | null = null
    if (!this.$store.getters.LOADING) {
      modeSelect = (<div class='game-mode-selections'>
        <div class='game-mode' onClick={this.modeSelect.bind(this, false)}>
          <h1>PLAY</h1>
        </div>
      </div>)
    }

    let tutorial: JSX.Element | null = null 
    if (!this.$store.getters.LOADING) {
      // @ts-ignore
      tutorial = (<div class='news-solo-wrapper'><NewsPanel article={tutorialPanel}></NewsPanel></div>)
    }

    return (
      <DefaultLayout>
        <div slot='navigation'>
          <h1 class='navigation-title'>QuickPicks</h1>
        </div>
        {tutorial}
        {modeSelect}
        {loader}
        <div class='news-card-holder'>
          {newsPanels}
        </div>
      </DefaultLayout>
    );
  }
}
